export const SECONDS_PER_DAY: number = 86400;
export const BYTES_TO_GB: number = 0.000000001;
export const SDL_HEADER = 'sdl-header.svg';
export const SDL_HEADER_HEIGHT: number = 48;
export const SDL_HEADER_WIDTH: number = 278;
export const SDL_STATE: string = 'sdl-state';
export const SDL_TITLE: string = 'SDL Sizing Calculator';
export const RESET_APP_STATE: string = 'reset-app';
export const ADMIN_PANEL_NAME: string = 'Admin Panel';
export const DEFAULT_CATEGORY_ID: number = 3;


// Header data for calculator device list items
export const CalculatorHeaderData = [
    {
        id: 0,
        display_name: 'Device Type',
        align_center: false
    },
    {
        id: 1,
        display_name: 'Quantity',
        description: 'Number of Devices',
        align_center: true
    },
    {
        id: 2,
        display_name: 'EPS',
        description: 'Events per Second',
        align_center: true
    },
    {
        id: 3,
        display_name: 'GB/Day',
        align_center: true
    }
]


// data for the retention period tabs
export const RetentionPeriodData = [
    {
        id: 0,
        name: 'daily',
        display_name: 'Daily',
        interval: 1
    },
    {
        id: 1,
        name: 'weekly',
        display_name: 'Weekly',
        interval: 7
    },
    {
        id: 2,
        name: 'monthly',
        display_name: 'Monthly',
        interval: 30
    },
    {
        id: 3,
        name: 'yearly',
        display_name: 'Yearly',
        interval: 365
    }
]


export const IndustryDetailData = [
    {
        id: 0,
        name: 'industry',
        display_name: 'Industry'
    },
    {
        id: 1,
        name: 'industry_size',
        display_name: 'Industry Size'
    },
    {
        id: 2,
        name: 'org_size',
        display_name: 'Organization Size'
    }
]
